import { render, staticRenderFns } from "./dhcp.vue?vue&type=template&id=ec97f334&scoped=true"
import script from "./dhcp.vue?vue&type=script&lang=ts"
export * from "./dhcp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec97f334",
  null
  
)

export default component.exports